module.exports = __webpack_public_path__ + "img/CJ_02.a6d50d50.webp";